import { Component, OnInit } from '@angular/core'
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms'
import { ActivatedRoute } from "@angular/router"
import { NotificationService } from '../../../../../../notification/shared/notification.service'
import { BasketService } from '../../../../../basket/shared/basket.service'
import { Porteur } from "../../../shared/porteur"

@Component({
  selector: 'app-casier',
  templateUrl: './casier.component.html',
  styleUrls: ['./casier.component.scss']
})
export class CasierComponent implements OnInit {

  porteur: Porteur;
  casierForm: FormGroup = new FormGroup({
    'newCasier': new FormControl('', [
      Validators.required
    ])
  })

  constructor(
    private route: ActivatedRoute,
    private basketService: BasketService,
    private notificationService: NotificationService) { }

  ngOnInit() {
    this.route.parent.data.subscribe(data => {
      this.porteur = data.porteur
      this.porteur.casier = null
    })
  }

  get newCasier(): AbstractControl {
    return this.casierForm.get('newCasier');
  }

  success() {
    this.notificationService.notif("Votre demande de changement de casier a été ajoutée au panier. Elle sera automatiquement supprimée sous 2 jours si elle n'est pas validée.", "notif");
  }

  submitForm() {
    if (null !== this.porteur && this.casierForm.valid) {
      this.basketService.addBasketLine({
        type: "CHANGEMENT CASIER",
        numPorteur: this.porteur.numPorteur,
        newCasier: this.newCasier.value,
        codeService: this.porteur.codeService,
      }).subscribe(res => this.success())
    }
  }
}
